import Env from "./env";

export const Logger = (...args) => {
    // For staging connect
    if (window.location.protocol + "//" + window.location.hostname + "/" === "https://stage.foo.redhat.com/" ||
        [Env.ConnectPortalUrls[Env.EnvNames.STAGE], Env.ConnectPortalUrls[Env.EnvNames.QA],
            Env.ConnectPortalUrls[Env.EnvNames.DEV], Env.ConnectPortalUrls[Env.EnvNames.UAT]]
            .indexOf(window.location.protocol + "//" + window.location.hostname + "/") >= 0) {
        console.log(...args);
    }
};